// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1ksgH","resendInfoText":"OnGoingPaymentBox_resendInfoText__3ArW_"};